import { render, staticRenderFns } from "./DeliveryOrder.vue?vue&type=template&id=059e7002"
import script from "./DeliveryOrder.vue?vue&type=script&lang=js"
export * from "./DeliveryOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports